import { Component } from '@angular/core';
import { IonicPage, NavController, ModalController } from 'ionic-angular';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { NgModule }      from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CalendarModal, CalendarModalOptions, CalendarResult } from "ion2-calendar";
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
//Providers
import { SBSuiteManager } from '../../modules/sbsuite/providers/sbsuite.manager';
//Decorators
import  { RedirectOnUserAttr } from '../../decorators/redirect-on-user-attr.decorator';
import { Subscriber } from 'rxjs';


/**
 * Página de ejemplo
 *
 * @export
 * @class Page1
 */
@RedirectOnUserAttr()
@IonicPage({
  name: 'Page1',
  segment: 'informes'
})
@Component({
  selector: 'page-page1',
  templateUrl: 'page1.html'
})
export class Page1 {

  /**
   * Contiene los textos traducidos.
   *
   * @type {*}
   * @memberof ManuallyClocking
   */
  texts: any = null;
   /**
   * Contiene la subscripción a translateService.onLangChange
   *
   * @private
   * @type {Subscriber<TranslationChangeEvent>}
   * @memberof ManuallyClocking
   */
  private _translateListener: Subscriber<TranslationChangeEvent> = null;

  /*columnDefs = [
      {headerName: 'MesH', field: 'Mes'},
      {headerName: 'BeneficioH', field: 'Beneficio'}
  ];
  rowData = [
      {make: 'Toyota', model: 'Celica', price: 35000},
      {make: 'Ford', model: 'Mondeo', price: 32000},
      {make: 'Porsche', model: 'Boxter', price: 72000}
  ];*/

  public dateFilter1 = moment();
  public dateFilter2 = moment();
  //public showSearchButton = false;
  /**
   * Devuelve la fecha de filtro incial en formato string: DD/MM/YYYY
   *
   * @type {string}
   * @memberof Page1
   */
  get dateStrFilter1(): string{
      return this.dateFilter1.format('DD/MM/YYYY');
  }
   /**
   * Devuelve la fecha de filtro final en formato string: DD/MM/YYYY
   *
   * @type {string}
   * @memberof Page1
   */
  get dateStrFilter2(): string{
    return this.dateFilter2.format('DD/MM/YYYY');
  }


  /**
   * Crea una instancia de Page1.
   * @param {NavController} navCtrl Controlador de navegación.
   * @memberof Page1
   */
  constructor(public navCtrl: NavController,
              public sbSuiteManager: SBSuiteManager,
              public modalCtrl: ModalController,
              public translateService: TranslateService) {

              this.getTranslate();
              this._translateListener = this.translateService.onLangChange.subscribe((event: TranslationChangeEvent) => {
                moment.locale(event.lang);
                this.getTranslate();
              });

              this.dateFilter1 = moment();
              this.dateFilter2 = moment();
              this.refrescarInforme();
  }

  getTranslate(): void{
    this.translateService.get([
      'WAIT_PLEASE',
      'SELECT_DATE_INTERVAL',
      'CANCEL',
      'DONE'
    ]).subscribe(res => {
      this.texts = res;
    });
  }

  refrescarInforme(): void{


    this.sbSuiteManager.getInformeTest(this.dateFilter1.format('YYYY-MM-DD'), this.dateFilter2.format('YYYY-MM-DD')).subscribe(
      result=>{
        if(result.isError()) {
          //alert("hola error2");
          //this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,result.getErrorMessage(),Date.now());
        }
        else{
          this.sbSuiteManager.sbSuite.informe = result.getData().Results;
          this.sbSuiteManager.sbSuite.informeColumns = result.getData().Columns;
          //console.log("OBJECTE QUE REBEM FINAL");
          //console.log(this.sbSuiteManager.sbSuite.informe);
          //this.showSearchButton = false; //Un cop refrescat amaguem el botó de refresc
          //this.events.publish(SBSuiteEvents.EVENTS.HISTORY_END,result.getData(),Date.now());
          //if(!result.getData().length) this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,'EMPTY_HISTORY',Date.now());
        }
      },
      error=>{
        //alert("hola error2");
        //this.events.publish(SBSuiteEvents.EVENTS.HISTORY_FAIL,error,Date.now());
      }
    )
  }

  openCalendar(): void {
    let weekDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    if(this.translateService.getDefaultLang() == 'es'){
      weekDays = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
    }
    if(this.translateService.getDefaultLang() == 'ca'){
      weekDays = ['Dg', 'Dll', 'Dm', 'Dm', 'Dj', 'Dv', 'Ds'];
    }

    let fromDate = new Date();
    fromDate.setFullYear(fromDate.getFullYear()-5);

    let cmOptions: CalendarModalOptions = {
      from: fromDate,
      defaultScrollTo: new Date(),
      title: this.texts.SELECT_DATE,
      weekStart: this.translateService.getDefaultLang()=='en'?0:1,
      weekdays: weekDays,
      format: 'DD/MM/YYYY',
      doneLabel: this.texts.DONE,
      closeLabel: this.texts.CANCEL,
      pickMode: 'range'
    };

    let myCalendar =  this.modalCtrl.create(CalendarModal, {
      options: cmOptions
    });

    myCalendar.present();

    myCalendar.onDidDismiss((date: CalendarResult, type: string) => {

      if(type == 'done'){
        this.dateFilter1 = moment(date['from'].string,'YYYY-MM-DD');
        this.dateFilter2 = moment(date['to'].string,'YYYY-MM-DD');
        //this.showSearchButton = true; //fem que es vegi el botó de refrescar (pq s'adonin que cal premer el botó de refresc)

        this.refrescarInforme();
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/page1/page1.ts